import { bannerManager } from '@envato/foundation-types'
import { ThunkAction } from 'redux-thunk'

import axiosVerbose from '../../utils/axios/axiosVerbose'
import { logError } from '../../utils/errors'

export enum TypeKeys {
  GET_BANNER_SUCCESS = 'GET_BANNER_SUCCESS',
  GET_BANNER_FAIL = 'GET_BANNER_FAIL'
}

export interface IGetBannerSuccessAction {
  type: TypeKeys.GET_BANNER_SUCCESS
  payload: bannerManager.headerBanners.IResult
}

export interface IGetBannerFailAction {
  type: TypeKeys.GET_BANNER_FAIL
}

export type ActionTypes = IGetBannerSuccessAction | IGetBannerFailAction

export const fetchBannerData = ({
  apiAppUrlPrefix,
  category = ''
}: {
  apiAppUrlPrefix: string
  category?: string
}): ThunkAction<any, any, any> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common
    const prefix = `${apiAppUrlPrefix}/shopfront-api`
    const apiUrl = `${prefix}/banner/${currentSite}/${category}`
    return axiosVerbose
      .get<bannerManager.headerBanners.IResult>(apiUrl)
      .then(response => {
        const successAction: IGetBannerSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_BANNER_SUCCESS
        }
        return dispatch(successAction)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        // if banner data fetch error, we simply report to rollbar
        // and don't do anything
        return dispatch({
          type: TypeKeys.GET_BANNER_FAIL
        })
      })
  }
}
